import { render, staticRenderFns } from "./cooperativeagency.vue?vue&type=template&id=960440e4&scoped=true&"
import script from "./cooperativeagency.vue?vue&type=script&lang=js&"
export * from "./cooperativeagency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960440e4",
  null
  
)

export default component.exports